import { render, staticRenderFns } from "./LastReceipts.vue?vue&type=template&id=fdf628be"
import script from "./LastReceipts.vue?vue&type=script&lang=js"
export * from "./LastReceipts.vue?vue&type=script&lang=js"
import style0 from "./LastReceipts.vue?vue&type=style&index=0&id=fdf628be&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports